import React from "react";
import { useParams } from "react-router-dom";
import { allCollegeData } from "../collegesData";
import CollegeList from "./ListingPage";

const CountryListingPage = () => {
 const { country } = useParams();
 const collegeData = allCollegeData[country];
 console.log("country:", country);
 if (!collegeData) {
  return <div>No data available for this country.</div>;
 }

 return <CollegeList collegeData={collegeData} />;
};

export default CountryListingPage;
